module.exports = __webpack_public_path__ + "img/template3.fa33369d.png";